import { useCompetitionByType } from "../../redux/features/categories/selectors";
import { CompetitionData } from "../../components/ActiveCompetitions/types";
import { FEATURED_COMPETITION_BG_COLOUR, FEATURED_COMPETITION_ENDS_TEXT_COLOUR } from "./header-constants";
import { getEndsInLabel } from "../../../helpers/endsIn";

const FeaturedSubscriberCompetitions = () => {
  const featuredCategory = useCompetitionByType("subscriberCompetitions");
  const onCompetitionClick = (competition: CompetitionData) => {
    if (competition.PageUrl) {
      location.href = competition.PageUrl;
    }
  };
  const onViewAllClick = () => {
    location.href = "/subscriber-competitions";
  };

  return (
    <div className="w-full min-w-0">
      <div className="bg-white rounded-lg lg:rounded-xl overflow-hidden">
        <div
          className="relative flex items-center w-full h-12 overflow-hidden pl-[99px] lg:pl-[107px]"
          style={{
            backgroundImage: "linear-gradient(183.69deg, #D7185D 0.38%, #24339F 50.32%)",
          }}>
          <img
            src="/assets/images/menu/pass-exclusive/decoration-mobile.webp"
            alt=""
            width={170}
            height={48}
            className="absolute left-0 top-0 h-12 w-auto max-w-none pointer-events-none lg:hidden"
          />
          <img
            src="/assets/images/menu/pass-exclusive/decoration-desktop.webp"
            alt=""
            width={170}
            height={48}
            className="absolute left-0 top-0 hidden lg:block h-12 w-auto max-w-none pointer-events-none"
          />
          <div className="relative z-[1] text-white font-jost text-base font-medium leading-5.5">PASS Exclusive</div>
        </div>
        <div className="flex flex-col items-center py-5 px-3 lg:px-4">
          <div className="flex flex-col items-center gap-5 w-full mb-5">
            {featuredCategory.competitions.slice(0, 1).map(competition => (
              <div
                key={competition.CompetitionId}
                onClick={() => onCompetitionClick(competition)}
                className="flex items-center w-full gap-2.5 lg:gap-[23px] cursor-pointer">
                <div className="flex items-center gap-1 shrink-0">
                  <div
                    className={`rounded-sm ${FEATURED_COMPETITION_BG_COLOUR[competition.NavigationColour as keyof typeof FEATURED_COMPETITION_BG_COLOUR] || "bg-nav-dark-blue"} h-12 lg:h-14 w-1`}
                  />
                  <div className="rounded overflow-hidden shrink-0">
                    {competition.ImageUrl ? (
                      <img
                        src={competition.ImageUrl}
                        alt={competition.Title || "PASS exclusive competition"}
                        width={56}
                        height={56}
                        className="object-cover size-12 rounded lg:size-14"
                      />
                    ) : null}
                  </div>
                </div>

                <div className="flex flex-col justify-center gap-1 lg:gap-2 min-w-0 flex-1">
                  <div className="text-dark-1 font-jost text-sm lg:text-base font-medium leading-4 lg:leading-[18px] break-words">
                    {competition.Title} {competition.AdditionalCashText}
                  </div>
                  <div className="flex items-center gap-3 flex-wrap">
                    <div
                      className={`font-jost text-xs font-medium leading-4 ${FEATURED_COMPETITION_ENDS_TEXT_COLOUR[competition.NavigationColour as keyof typeof FEATURED_COMPETITION_ENDS_TEXT_COLOUR] || "text-nav-dark-blue"}`}>
                      Ends {getEndsInLabel(competition.EndDate)}
                    </div>
                  </div>
                </div>

                <div
                  className={
                    "flex items-center justify-center shrink-0 uppercase bg-[#EEEEEF] rounded-lg w-14 lg:w-20 h-8 lg:h-10 text-nav-azure font-jost text-xs lg:text-sm font-medium"
                  }>
                  Enter
                </div>
              </div>
            ))}
          </div>
          <button
            type="button"
            onClick={onViewAllClick}
            className="mt-auto flex items-center text-nav-azure cursor-pointer">
            <span className="font-jost text-[13px] font-medium leading-4.5">
              VIEW ALL ({featuredCategory.competitions.length})
            </span>
            <svg
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              aria-hidden="true">
              <path
                d="M8.33325 5.83334L12.4999 10L8.33325 14.1667"
                stroke="#3772FF"
                strokeWidth="1.66667"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </button>
        </div>
      </div>
    </div>
  );
};

export default FeaturedSubscriberCompetitions;
